module.exports = __webpack_public_path__ + "static/open-graph-971b8d48c2fd82424c861d6537d8a8f5.png";